import { MusicGameCharacter } from "GameObjects/MusicGame/Character";

export class MusicGameOscar extends MusicGameCharacter {

    protected animations = {
        idle: "Idle",
        idleToReady: "Idle To Ready",
        ready: "Ready To Play",
        playing: "Playing",
    };

    constructor(pData: {id: number}) {
        super({name: 'oscar', skeleton: 'Oscar Front', ...pData});
        this.playAnimation(this.animations.idle);
        this._spine.update(0);
    }

}